export default __webpack_public_path__ + "ca1e738e4f349f27514d329d755c429c.woff";